import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// 跨页滚动管理：
// 1. 普通新页面导航 → 回到顶部（修复从首页进入内页仍停留原 scrollY 的问题）；
// 2. 带 #hash 锚点 → 定位到对应区块；
// 3. 前进/后退 → 恢复该路径上次离开时的滚动位置。
// 仅在 location 变化时执行，不在每次组件渲染时强制回顶部。
const scrollCache = new Map<string, number>();

export default function ScrollToTop() {
  const location = useLocation();
  const previousKey = useRef('');

  useEffect(() => {
    const key = location.pathname + location.search;

    // 记录离开页面的滚动位置，供前进/后退恢复
    if (previousKey.current && previousKey.current !== key) {
      scrollCache.set(previousKey.current, window.scrollY);
    }
    previousKey.current = key;

    // 带锚点 → 定位到对应区块
    if (location.hash) {
      const id = decodeURIComponent(location.hash.slice(1));
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ block: 'start' });
        return;
      }
    }

    // 前进/后退恢复上次滚动位置；普通新页面回到顶部
    const saved = scrollCache.get(key);
    window.scrollTo(0, saved ?? 0);
  }, [location.pathname, location.search, location.hash]);

  return null;
}